import { render, staticRenderFns } from "./MethodComponentEditor.vue?vue&type=template&id=58b24be0&"
import script from "./MethodComponentEditor.vue?vue&type=script&lang=js&"
export * from "./MethodComponentEditor.vue?vue&type=script&lang=js&"
import style0 from "./MethodComponentEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports